import SpamUsersFilters from './SpamUsersFilters';

export default SpamUsersFilters;
